function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCss3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "30px",
    height: "30px",
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(14.901961%,30.196078%,89.411765%)",
      fillOpacity: 1
    },
    d: "M 4.21875 26.953125 L 1.757812 0 L 28.183594 0 L 25.78125 26.953125 L 15 30 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(16.078431%,39.607843%,94.509804%)",
      fillOpacity: 1
    },
    d: "M 15 2.167969 L 15 27.65625 L 23.730469 25.253906 L 25.78125 2.167969 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.156863%,92.156863%,92.156863%)",
      fillOpacity: 1
    },
    d: "M 6.679688 5.507812 L 15 5.507812 L 15 8.789062 L 6.972656 8.789062 M 7.265625 12.1875 L 15 12.1875 L 15 15.527344 L 7.558594 15.527344 M 7.734375 17.167969 L 11.015625 17.167969 L 11.25 19.804688 L 15 20.800781 L 15 24.257812 L 8.144531 22.382812 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 15 12.1875 L 15 15.527344 L 19.042969 15.527344 L 18.632812 19.804688 L 15 20.800781 L 15 24.257812 L 21.738281 22.382812 L 23.261719 5.507812 L 15 5.507812 L 15 8.789062 L 19.6875 8.789062 L 19.367188 12.1875 Z M 15 12.1875 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCss3);
export default __webpack_public_path__ + "static/media/css3.ca28d67a8ed967b7440accf85639323e.svg";
export { ForwardRef as ReactComponent };